/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as MsDyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';

import { ITextBlockProps } from './text-block.props.autogenerated';

export interface ITextBlockViewProps extends ITextBlockProps<{}> {
    paragraph?: React.ReactNode;
    className?: string;
}

/**
 *
 * TextBlock component.
 */
class TextBlock extends React.PureComponent<ITextBlockProps<{}>> {
    public render(): JSX.Element | null {
        const { paragraph, className } = this.props.config;
        const text = paragraph && <MsDyn365.RichTextComponent text={paragraph} editProps={{ onEdit: this.handleTextChange, requestContext: this.props.context.request }} />;
        const textBlockViewProps = {
            ...this.props,
            paragraph: text,
            className: classnames('ms-text-block', className)

        };
        return this.props.renderView(textBlockViewProps) as React.ReactElement;
    }

    public handleTextChange = (event: MsDyn365.ContentEditableEvent) => this.props.config.paragraph = event.target.value;
}
export default TextBlock;
